import type { FaireThemeEntity } from "../../entity_types/theme";

export const affordable_boutique_glamour: FaireThemeEntity = {
  token: "affordable-boutique-glamour",
  type: "theme",
  name: "Affordable Boutique Glamour",
  description: "Elegant jewelry sets with cubic zirconia and 18K gold plating at accessible price points.",
  teaser: "Quick luxury additions -- retail $24-38, wholesale under $12.",
  detail: "Retail prices $24-38, perfectly positioned for San Jose patrons wanting a quick luxury addition. The Rhinestone Letter Bracelet and CZ Mix Earring Set provide glamorous aesthetic with wholesale prices under $12.",
  bgColor: "#D4EEF0",
  exactProducts: true,
  retailerToken: "r_v79pcsx8up",
  productTokens: [
    "p_85zuvdfqvw",
    "p_ut3tbs6mrw",
    "p_pqf2f49nzz",
    "p_ufjavmwa64",
    "p_nrg5hxcuy3",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00Z",
    importedBy: "manual-v2-import",
  },
};
